import { userAgent } from '@tink/tink-link-core/src/user-agent-detector';
import { Provider, ProviderEntity } from '../../../models/provider';
import { useUrlQuery } from '../../../components/ApplicationProviders/UrlQueryProvider/UrlQueryProvider';
import { SubmitCredentialsPayload } from '../../../components/screens/SubmitCredentials/hooks/useSubmitCredentials/useSubmitCredentials';
import { SubmitCredentialsScreen } from '../../../components/screens/molecules/SubmitCredentialsScreen/types';
import { ConsentScreen as ConsentScreenDefault } from '../../../components/screens/molecules/SubmitCredentialsScreen/screens/ConsentScreen/ConsentScreen';
import { NoFieldsScreen as NoFieldsScreenDefault } from '../../../components/screens/molecules/SubmitCredentialsScreen/screens/NoFieldsScreen/NoFieldsScreen';
import { BackButton } from '../../../components/organisms/Header/HeaderMolecule';

export type MaybeNoFieldsScreenProps = {
  children?: JSX.Element;
  provider: ProviderEntity;
  onSubmit: (credentials: SubmitCredentialsPayload) => void;
  isMobile?: boolean;
  ConsentScreen?: SubmitCredentialsScreen;
  NoFieldsScreen?: SubmitCredentialsScreen;
} & BackButton;

export const MaybeNoFieldsScreen = ({
  children,
  provider,
  onBack,
  onSubmit,
  isMobile = userAgent.isMobile,
  ConsentScreen = ConsentScreenDefault,
  NoFieldsScreen = NoFieldsScreenDefault,
}: MaybeNoFieldsScreenProps) => {
  const { providerName: isProviderPreselected } = useUrlQuery();
  const shouldShowNoFieldsScreen = !Provider.hasFields(provider);

  const shouldShowConsentRedirectScreen =
    isMobile && shouldShowNoFieldsScreen && isProviderPreselected;

  if (shouldShowNoFieldsScreen) {
    if (shouldShowConsentRedirectScreen) {
      return <ConsentScreen onSubmit={onSubmit} onBack={onBack} />;
    }

    return <NoFieldsScreen onSubmit={onSubmit} onBack={onBack} />;
  }

  return <div>{children}</div>;
};
